export default "__VITE_ASSET__BKB7RaVy__"